import React, { useState, useEffect } from 'react';
import './Despacho.css';

/**
 * DespachoDetalle
 * Componente para mostrar productos pendientes de un despacho
 */
const DespachoDetalle = ({ idDespacho }) => {
  const [productosPendientes, setProductosPendientes] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (idDespacho) {
      cargarProductosPendientes(idDespacho);
    } else {
      setProductosPendientes([]);
    }
  }, [idDespacho]);

  const cargarProductosPendientes = async (id) => {
    setCargando(true);
    setError(null);
    try {
      const response = await fetch(`/api/despacho/${id}/productos-pendientes`);
      const data = await response.json();
      if (data.success === true && Array.isArray(data.productosPendientes)) {
        setProductosPendientes(data.productosPendientes);
      } else {
        setProductosPendientes([]);
        setError(data.message || 'No se encontraron productos pendientes');
      }
    } catch (err) {
      setError(err.message || 'Error al cargar productos');
      setProductosPendientes([]);
    } finally {
      setCargando(false);
    }
  };

  if (!idDespacho) {
    return (
      <div className="despacho-alert alert-error">ID de despacho no válido.</div>
    );
  }

  if (cargando) {
    return <div className="despacho-loading">Cargando productos...</div>;
  }

  return (
    <div className="detalle-despacho">
      {error && (
        <div className="despacho-alert alert-error" style={{ marginBottom: '1rem' }}>
          <strong>Error:</strong> {error}
        </div>
      )}

      <div className="card">
        <div className="card-header bg-light d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            <i className="fas fa-box-open"></i> Productos del Despacho
          </h5>
        </div>

        <div className="card-body p-0">
          {productosPendientes.length === 0 ? (
            <div className="despacho-loading" style={{ padding: '1.5rem' }}>
              No hay productos para mostrar.
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-hover mb-0">
                <thead className="thead-light">
                  <tr>
                    <th style={{ width: '60px' }}>#</th>
                    <th style={{ width: '120px' }}>Código</th>
                    <th style={{ width: '140px', textAlign: 'center' }}>Cantidad</th>
                    <th>Producto</th>
                    <th style={{ width: '120px' }}>Unidad</th>
                  </tr>
                </thead>
                <tbody>
                  {productosPendientes.map((p, idx) => (
                    <tr key={(p.CodigoProducto || idx) + '_' + idx}>
                      <td>{idx + 1}</td>
                      <td>{p.CodigoProducto || '-'}</td>
                      <td style={{ textAlign: 'center' }}><span className="text-monospace">{parseFloat(p.CantidadDespachada || 0).toFixed(2)}</span></td>
                      <td><span className="text-monospace">{(p.NombreProducto || '-') + (p.Presentacion ? ` (${p.Presentacion})` : '')}</span></td>
                      <td>{p.UnidadMedida || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DespachoDetalle;
